import React from "react";
import { Route, Switch } from "react-router-dom";

import { GoldlinkProductFinderForm } from "./goldlink-product-finder";
import { OrderRoutingForm } from "./order-routing";

export default () => {
    return {
        routes: [
            {
                path: "/test-harnesses",
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}/goldlink-product-finder`}
                            exact
                            component={GoldlinkProductFinderForm}
                        />
                        <Route
                            path={`${match.url}/order-routing`}
                            exact
                            component={OrderRoutingForm}
                        />
                    </Switch>
                ),
            },
        ],
    };
};
